var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "link-block container-fluid layout-without-background"
  }, [_c('ul', {
    staticClass: "list list-unstyled row flex-nowrap flex-lg-wrap justify-content-start",
    class: _vm.currentPayload.blocks.length === 2 ? 'justify-content-lg-around' : 'justify-content-lg-center'
  }, _vm._l(_vm.elements, function (block, index) {
    return _c('li', {
      key: index,
      staticClass: "col-10 col-md-5 px-md-down",
      class: {
        'col-lg-4': _vm.currentPayload.blocks.length <= 3,
        'col-lg-3': _vm.currentPayload.blocks.length >= 4
      }
    }, [_c('section', [_c(block.url ? 'a' : 'div', {
      tag: "component",
      class: {
        link: block.url
      },
      attrs: {
        "href": block.url,
        "target": block.target
      }
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('div', {
      staticClass: "ratio-img image-container mt-3 mt-lg-1"
    }, [_c('img', {
      staticClass: "lazyload img-fluid image",
      attrs: {
        "data-srcset": "".concat(block.image.small, " 150w"),
        "data-src": block.image.small,
        "data-sizes": "auto",
        "alt": block.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('GlobalTitle', {
      staticClass: "d-inline-block",
      attrs: {
        "title": block.title
      }
    }), _vm._v(" "), _c('mdm-icon', {
      staticClass: "icon",
      class: {
        'd-none': !block.url
      },
      attrs: {
        "size": "11",
        "name": "chevron-right"
      }
    }), _vm._v(" "), _c('SimpleParagraph', {
      attrs: {
        "paragraph": block.paragraph
      }
    })], 1)])])], 1)]);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };